module.exports = __webpack_public_path__ + "img/add_btn_icon470.611911f3.svg";